<template>
  <table id="benner-data-table-vue" class="table table-hover cell-border">
    <slot id="thead"></slot>
    <slot id="tbody"></slot>
    <slot id="tfloor"></slot>
  </table>
</template>

<script>
require("datatables/media/js/jquery.dataTables");

export default {
  props: {
    dataObject: {}
  },
  watch: {
    dataObject: function() {
      if (this.dataObject === undefined) return;

      var $tabela = $("#benner-data-table-vue");
      // Evita "Cannot reinitialise DataTable": se a instancia anterior nao
      // foi destruida (modal fechada por backdrop/ESC, ou analitico reaberto
      // / trocado de celula), destroi antes de recriar.
      if ($.fn.dataTable.isDataTable($tabela)) {
        $tabela.DataTable().clear().destroy();
      }

      $tabela.DataTable({
          // Larguras controladas manualmente (alca de redimensionamento):
          // o DataTables nao deve recalcular a cada redraw/paginacao.
          autoWidth: false,
          language: {
            loadingRecords: "Buscando...",
            search: "Procurar por:",
            lengthMenu: "Exibir _MENU_ por pagina",
            info: "Exibindo página _PAGE_ de _PAGES_",
            "zeroRecords:":
              "Nenhum registro encontrado com o filtro informado.",
            paginate: {
              previous: "Anterior",
              next: "Próxima"
            }
          },
          columnDefs: [
            { className: "encolherColuna", targets: "_all" },
            {
              targets: "_all",
              createdCell: function(td, cellData, rowData, row, col) {
                $(td).attr("data-toggle", "tooltip");
                $(td).attr("title", cellData);
              }
            }
          ],
          data: this.dataObject.Data,
          columns: this.dataObject.Headers,
          initComplete: function() {
            tornarColunasRedimensionaveis($tabela);
          }
        });
    }
  }
};

// Torna as colunas do DataTable redimensionaveis pelo usuario, arrastando a
// borda direita do cabecalho. O DataTables nao tem isso nativo; a implementacao
// abaixo e independente (jQuery + DOM), sem plugin adicional.
//
// Chamada no initComplete do DataTable: injeta as alcas e agenda o ajuste de
// largura para quando o modal estiver VISIVEL. Medir com o modal oculto retorna
// largura 0 (tudo cairia no minimo), por isso o ajuste roda no shown.bs.modal.
function tornarColunasRedimensionaveis($tabela) {
  var tabela = $tabela[0];
  if (!tabela) return;

  injetarAlcasRedimensionamento($tabela, tabela);

  var $modal = $("#modalExemplo");
  // Reaplica ao abrir o modal (medindo ja visivel). Namespaced + off/on para
  // nao empilhar handlers a cada reabertura/troca de celula.
  $modal.off("shown.bs.modal.redimensionarColuna");
  $modal.on("shown.bs.modal.redimensionarColuna", function() {
    ajustarLargurasNaturais($tabela, tabela);
  });

  // Modal ja aberto (troca de celula sem fechar): o shown nao dispara de novo,
  // entao ajusta na hora.
  if ($modal.is(":visible")) {
    ajustarLargurasNaturais($tabela, tabela);
  }
}

// Mede a largura natural (ajustada ao conteudo) de cada coluna e a fixa. Antes
// de medir, reseta o layout para AUTO e limpa larguras de aberturas anteriores
// (o elemento <table> persiste entre reinits, entao viria com table-layout:fixed
// e larguras antigas, contaminando a medicao).
function ajustarLargurasNaturais($tabela, tabela) {
  var ths = $tabela.find("thead th").toArray();
  if (!ths.length) return;

  tabela.style.tableLayout = "auto";
  tabela.style.width = "";
  ths.forEach(function(th) {
    th.style.width = "";
  });

  // Mede o conteudo real, limitando a uma faixa razoavel para uma coluna muito
  // longa nao nascer gigante.
  var larguras = ths.map(function(th) {
    return Math.min(400, Math.max(60, th.offsetWidth));
  });

  // table-layout: fixed faz a largura do <th> valer para a coluna toda (e o
  // text-overflow: ellipsis do <td> passa a funcionar de fato).
  tabela.style.tableLayout = "fixed";
  var total = 0;
  ths.forEach(function(th, i) {
    th.style.width = larguras[i] + "px";
    total += larguras[i];
  });
  // Largura total = soma das colunas, para gerar rolagem horizontal no modal
  // quando ultrapassar o container (em vez de espremer as vizinhas).
  tabela.style.width = total + "px";
}

// Injeta a alca de arraste na borda direita de cada cabecalho.
function injetarAlcasRedimensionamento($tabela, tabela) {
  $tabela.find("thead th").toArray().forEach(function(th) {
    // Evita duplicar a alca caso a funcao rode mais de uma vez sobre o mesmo th.
    if (th.querySelector(".redimensionador-coluna")) return;

    // O DataTables ja poe position:relative no th; garantimos por seguranca.
    th.style.position = "relative";

    var alca = document.createElement("span");
    alca.className = "redimensionador-coluna";
    // Estilos criticos INLINE: nao dependem do bundle de CSS (que pode estar em
    // cache antigo). Sem isso a alca fica com largura 0 e sem cursor col-resize,
    // impossibilitando o arraste.
    alca.style.cssText =
      "position:absolute;top:0;right:0;width:8px;height:100%;" +
      "cursor:col-resize;user-select:none;z-index:5;";
    th.appendChild(alca);

    var xInicial;
    var larguraColInicial;
    var larguraTabInicial;

    function mover(e) {
      var novaCol = Math.max(40, larguraColInicial + (e.pageX - xInicial));
      var deltaReal = novaCol - larguraColInicial;
      th.style.width = novaCol + "px";
      tabela.style.width = larguraTabInicial + deltaReal + "px";
    }

    function soltar() {
      $(document).off("mousemove.redimensionarColuna");
      $(document).off("mouseup.redimensionarColuna");
      $("body").css("cursor", "");
    }

    $(alca).on("mousedown", function(e) {
      xInicial = e.pageX;
      larguraColInicial = th.offsetWidth;
      larguraTabInicial = tabela.offsetWidth;
      $(document).on("mousemove.redimensionarColuna", mover);
      $(document).on("mouseup.redimensionarColuna", soltar);
      $("body").css("cursor", "col-resize"); // feedback durante o arraste
      e.preventDefault();
      e.stopPropagation(); // nao dispara a ordenacao do cabecalho
    });

    // Realce visual ao passar o mouse (equivalente ao :hover do CSS, mas inline
    // para nao depender do bundle).
    $(alca).on("mouseenter", function() {
      alca.style.backgroundColor = "#037fff";
    });
    $(alca).on("mouseleave", function() {
      alca.style.backgroundColor = "";
    });

    // O clique que fecha o arraste nao deve ordenar a coluna.
    $(alca).on("click", function(e) {
      e.stopPropagation();
    });
  });
}

$(document).ready(function() {
  $('[data-toggle="tooltip"]').tooltip();
});
</script>
<style>
/* A largura da coluna passa a ser controlada pela alca de redimensionamento
   (table-layout: fixed no ajuste). O ellipsis mantem a leitura quando o usuario
   encolhe a coluna abaixo do tamanho do conteudo; o valor completo fica no
   tooltip (title). */
.encolherColuna {
  white-space: nowrap;
  word-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
